import { Point } from 'models';

const getDistanceBetweenTwoPoints = (start: Point, end: Point) => {
    const x = start.x - end.x;
    const y = start.y - end.y;

    return Math.hypot(x, y);
};

export { getDistanceBetweenTwoPoints };
